import { Logo } from "components/Logo";
import type { LogoAdapterProps } from "./Logo.d";

const LogoAdapter = ({ blok: { logo, logoWidth, color } }: LogoAdapterProps) => (
  <Logo logo={logo} logoWidth={logoWidth} color={color} />
);

export default LogoAdapter;
